module.exports = __webpack_public_path__ + "static/media/home.9203cd2b.svg";